import { memo } from 'react'

import SelectOptionsNode from '../SelectOptionsNode'

const SelectOptionsActionNode = ({ ...props }) => {
  return <SelectOptionsNode label={'Seleccionar opciones'} {...props} />
}
export default memo(SelectOptionsActionNode)
